import Header from "../components/Header";
import Footer from "../components/Footer";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      <main className="max-w-4xl mx-auto px-4 py-24">
        <h1 className="font-heading text-4xl font-bold text-slate-900 mb-8">
          Politique de Confidentialité
        </h1>
        
        <div className="prose prose-slate max-w-none space-y-8">
          <section>
            <h2 className="font-heading text-2xl font-semibold text-slate-800 mb-4">
              1. Collecte des données
            </h2>
            <p className="text-slate-600 leading-relaxed">
              LLDLS Smart Energy collecte les informations personnelles suivantes lors de votre demande de devis : 
              nom, prénom, adresse email, numéro de téléphone, code postal, ainsi que les informations relatives 
              à votre projet de toiture (type de projet, type de bien, surface approximative, niveau d'urgence).
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-slate-800 mb-4">
              2. Utilisation des données
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Vos données personnelles sont utilisées exclusivement pour :
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-slate-600">
              <li>Vous recontacter dans le cadre de votre demande de devis</li>
              <li>Établir un devis personnalisé pour vos travaux de toiture</li>
              <li>Améliorer nos services et votre expérience client</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-slate-800 mb-4">
              3. Durée de conservation
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Vos données sont conservées pendant une durée de 3 ans à compter de votre dernière interaction 
              avec LLDLS Smart Energy, conformément aux recommandations de la CNIL.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-slate-800 mb-4">
              4. Vos droits
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :
            </p>
            <ul className="list-disc pl-6 mt-4 space-y-2 text-slate-600">
              <li><strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles</li>
              <li><strong>Droit de rectification :</strong> corriger des données inexactes</li>
              <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
              <li><strong>Droit à la limitation :</strong> limiter le traitement de vos données</li>
              <li><strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré</li>
              <li><strong>Droit d'opposition :</strong> vous opposer au traitement de vos données</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-slate-800 mb-4">
              5. Sécurité
            </h2>
            <p className="text-slate-600 leading-relaxed">
              LLDLS Smart Energy met en œuvre toutes les mesures techniques et organisationnelles 
              appropriées pour protéger vos données personnelles contre tout accès non autorisé, 
              toute modification, divulgation ou destruction.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-slate-800 mb-4">
              6. Contact
            </h2>
            <p className="text-slate-600 leading-relaxed">
              Pour exercer vos droits ou pour toute question relative à la protection de vos données, 
              vous pouvez nous contacter à l'adresse suivante : <strong>lldlsgroupe@gmail.com</strong>
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl font-semibold text-slate-800 mb-4">
              7. Modifications
            </h2>
            <p className="text-slate-600 leading-relaxed">
              LLDLS Smart Energy se réserve le droit de modifier cette politique de confidentialité 
              à tout moment. Les modifications entrent en vigueur dès leur publication sur ce site.
            </p>
            <p className="text-slate-500 mt-4 text-sm">
              Dernière mise à jour : Janvier 2026
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPage;
